import { render, staticRenderFns } from "./SwappTasksCommentsDialog.vue?vue&type=template&id=9d0ac5c6&scoped=true&"
import script from "./SwappTasksCommentsDialog.vue?vue&type=script&lang=js&"
export * from "./SwappTasksCommentsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d0ac5c6",
  null
  
)

export default component.exports